import React, { useRef, useState, useEffect, Fragment, Component } from "react";
import UploadService from "./upload-files.service";
import Divider from "@mui/material/Divider";
import Dialog from "@mui/material/Dialog";
import "bootstrap/dist/css/bootstrap.min.css";
import FileUpload from "./FileUpload";
import axios from "../../../../api/axios";
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import {
  Typography,
  Paper,
  Link,
  Grid,
  Radio,
  Select,
  Button,
  TextField,
  Checkbox,
  CssBaseline,
  RadioGroup,
  FormLabel,
  MenuItem,
  FormGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";

import "../Operations.css";
import "bootstrap/dist/css/bootstrap.min.css";

export default function FileUploadDlg(
//   {
//   open,
//   onClose,
//   tmpOrderId,
//   tmpUserId,
// }
) {
  const [selectedFiles, setSelectedFiles] = useState(undefined);
  const [currentFile, setCurrentFile] = useState(undefined);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState("");
  const [fileInfos, setFileInfos] = useState([]);
  const [openDialogName, setOpenDialog] = useState(null);

  const closeDialog = () => {
    setOpenDialog(null);
    //paymentId.current = 0;
  };

  const openDialog = () => {
    //alert('OpenDialog =======>    ' + userId);
    /*alert('Selected Userid====' + userId);
    switch (openDialogName) {
      case 1:
        setOpenDialog(openDialogName);
        handleClose();
    }*/
  };

  const selectFile = (event) => {
    setSelectedFiles(event.target.files);
  };

  const upload = () => {
    let currentFile = selectedFiles[0];

    setProgress(0);
    setCurrentFile(currentFile);

    UploadService.upload(currentFile, (event) => {
      setProgress(Math.round((100 * event.loaded) / event.total));
    })
      .then((response) => {
        setMessage(response.data.message);
        return UploadService.getFiles();
      })
      .then((files) => {
        setFileInfos(files.data);
      })
      .catch(() => {
        setProgress(0);
        setMessage("Could not upload the file!");
        setCurrentFile(undefined);
      });

    setSelectedFiles(undefined);
  };

  return (
    <div>
      {/* <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        PaperProps={{
          style: {
            Height: "950px",
            minHeight: "500px",
            minWidth: "700px",
            maxWidth: "700px",
          },
        }}
      > */}
        <div style={{ padding: 25, paddingTop: 10, paddingBottom: 10 }}>
          {/* <FileUpload selectedOrderId={tmpOrderId} selectedUserId={tmpUserId} /> */}
          <FileUpload />
        </div>
      {/* </Dialog> */}
    </div>
  );
}
